export default "__VITE_ASSET__BD4E8I0s__"